import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { UserService } from '../../service/user.service';
import { playlist } from '../../models/playlist.model';
import { media } from '../../models/media.model';
import { PlayerService } from '../../service/player.service';

/**
 * Generated class for the PlaylistPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-playlist',
  templateUrl: 'playlist.html',
})
export class PlaylistPage {

  playlist:playlist;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public us: UserService, private ps: PlayerService, private alertCtrl: AlertController) {
  }

 ngOnInit()
 {
   this.playlist = this.navParams.get("playlist");
 }

 reorderItems(indexes) {
  let element = this.playlist.medias[indexes.from];
  this.playlist.medias.splice(indexes.from, 1);
  this.playlist.medias.splice(indexes.to, 0, element);

  var order_str = "";
  this.playlist.medias.forEach((m:media) => {
    order_str += m.id + ",";
  });
  
  this.us.setPlaylistOrder(this.playlist.id, order_str);

}

removePost(media){
  let index = this.playlist.medias.indexOf(media);

  if(index > -1){
    this.playlist.medias.splice(index, 1);
  }

  var order_str = "";
  this.playlist.medias.forEach((m:media) => {
    order_str += m.id + ",";
  });
  
  this.us.setPlaylistOrder(this.playlist.id, order_str);

}

titleChange()
{
  this.us.setPlaylistTitle(this.playlist.id, this.playlist.title);
}

remove()
{

  const prompt = this.alertCtrl.create({
    title: 'Radera',
    message: "Är du säker på att du vill ta bort spellistan?",
    buttons: [
      {
        text: 'Avbryt',
        handler: data => {
          console.log('Cancel clicked');
        }
      },
      {
        text: 'Ta bort',
        handler: data => {
          this.us.removePlaylist(this.playlist.id);
          this.navCtrl.pop();
        }
      }
    ]
  });
  prompt.present();


}

play()
{
    this.ps.playList = this.playlist.medias;
    this.ps.load(this.ps.playList[0].id, true);
}


}



// WEBPACK FOOTER //
// ./src/pages/playlist/playlist.ts